import { Icon } from "@iconify/react";
import { format, isSameDay } from "date-fns";
import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";

const InspectionDateFilter = ({
  startDate,
  endDate,
  onApply,
  onClear,
}) => {
  const [show, setShow] = useState(false);
  const [draftStartDate, setDraftStartDate] = useState(null);
  const [draftEndDate, setDraftEndDate] = useState(null);
  const isActive = Boolean(startDate && endDate);

  const openFilter = () => {
    setDraftStartDate(startDate);
    setDraftEndDate(endDate);
    setShow(true);
  };

  const handleDateRangeChange = ([start, end]) => {
    setDraftStartDate(start);
    setDraftEndDate(end);
  };

  const applyFilter = () => {
    if (!draftStartDate) {
      return;
    }

    onApply(draftStartDate, draftEndDate || draftStartDate);
    setShow(false);
  };

  const clearFilter = () => {
    setDraftStartDate(null);
    setDraftEndDate(null);
    onClear();
    setShow(false);
  };

  const filterLabel = isActive
    ? isSameDay(startDate, endDate)
      ? `Inspection date: ${format(startDate, "dd MMM yyyy")}`
      : `Inspection dates: ${format(startDate, "dd MMM yyyy")} – ${format(
          endDate,
          "dd MMM yyyy",
        )}`
    : "Filter by inspection date";

  return (
    <>
      <button
        type="button"
        className={`btn inspection-date-filter ${
          isActive ? "inspection-date-filter--active" : ""
        }`}
        onClick={openFilter}
        title={filterLabel}
        aria-label={filterLabel}
      >
        <Icon icon="mdi:calendar-range" width="18" height="18" />
      </button>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        centered
        className="modalPopup"
      >
        <Modal.Header closeButton>
          <Modal.Title>Filter by Inspection Date</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <p className="text-center text-muted mb-3">
            Select one date, or select a start and end date for a range.
          </p>
          <div className="datePickerIcon d-flex justify-content-center">
            <DatePicker
              selected={draftStartDate}
              onChange={handleDateRangeChange}
              startDate={draftStartDate}
              endDate={draftEndDate}
              selectsRange
              inline
              monthsShown={1}
              calendarClassName="shadow-sm"
            />
          </div>
          {draftStartDate && (
            <div className="inspection-date-filter__selection mt-3 p-3 rounded text-center">
              <strong>
                {draftEndDate &&
                !isSameDay(draftStartDate, draftEndDate)
                  ? "Selected range"
                  : "Selected date"}
                :
              </strong>
              <div className="mt-1">
                {format(draftStartDate, "dd MMM yyyy")}
                {draftEndDate &&
                  !isSameDay(draftStartDate, draftEndDate) &&
                  ` – ${format(draftEndDate, "dd MMM yyyy")}`}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={clearFilter}
            disabled={!isActive && !draftStartDate}
          >
            Clear filter
          </Button>
          <Button
            variant="primary"
            onClick={applyFilter}
            disabled={!draftStartDate}
          >
            Apply filter
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default InspectionDateFilter;
